// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"5bf3ba84","732":"57e53aa3"}[chunkId] + ".chunk.js");